import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export default theme => ({
  root: {},
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    height: '100%'
  },
  left: {
    height: 'calc(100% - 2px)',
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '36px',
    border: `1px solid ${theme.colors.grey[100]}`,
    borderRadius: 8
  },
  leftContent: {
    width: 'calc(100% - 24px)',
    height: 'calc(100% - 24px)'
  },
  right: {
    width: 417,
    height: '100%'
  },
  tabs: {},
  filtersTab: {
    display: 'flex',
    gap: '4px'
  },
  tabsContainer: {
    height: '40px'
  },
  formContainer: _objectSpread(_objectSpread({
    height: 'calc(100% - 40px)',
    width: '100%',
    overflowY: 'auto'
  }, theme.utils.scrollbar), {}, {
    boxSizing: 'border-box',
    padding: '12px 0'
  }),
  loader: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  crudFields: {
    width: '100%'
  },
  crudFilters: {
    width: '100%',
    height: '100%',
    display: 'block'
  },
  hidden: {
    display: 'none'
  }
});